
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/teach",
      function () {
        return require("private-next-pages/teach.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/teach"])
      });
    }
  